import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './sainik.component.html',
  styleUrls: ['./sainik.component.css']
})
export class AppComponent {
  title = 'Sainik';
}



// WEBPACK FOOTER //
// ./src/app/sainik.component.ts